import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcSensors = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M12.083 5.425a1 1 0 0 1 1.15-.824A7.505 7.505 0 0 1 19.4 10.77a1 1 0 1 1-1.973.326 5.506 5.506 0 0 0-4.52-4.52 1 1 0 0 1-.824-1.15Zm-6.658 6.658a1 1 0 0 1 1.15.823 5.506 5.506 0 0 0 4.52 4.52 1 1 0 1 1-.326 1.974A7.505 7.505 0 0 1 4.6 13.233a1 1 0 0 1 .824-1.15Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M11.833 1.952a1 1 0 0 1 1.079-.914c5.348.44 9.61 4.702 10.05 10.05a1 1 0 0 1-1.993.164 9.002 9.002 0 0 0-8.221-8.221 1 1 0 0 1-.915-1.079Zm-9.882 9.882a1 1 0 0 1 1.079.915 9.002 9.002 0 0 0 8.22 8.22 1 1 0 0 1-.163 1.994 11.002 11.002 0 0 1-10.05-10.05 1 1 0 0 1 .914-1.079Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: "12",
  cy: "12",
  fill: "var(--mds-nav-icon-accent)",
  r: "3"
})), "IcSensors");

export { IcSensors };
//# sourceMappingURL=ic-sensors.js.map
